import { useLocation, useNavigate } from 'react-router-dom'
import { useParams } from 'react-router-dom'

import { Text } from '@factorialco/deprecated-design-system'
import { ActivateProjectDocument, ActivateProjectMutation } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'

import SingleActionModal from 'modules/project_management/components/modals/SingleActionModal'

const ActivateProjectModalPage = () => {
  const { projectId } = useParams()
  const { state } = useLocation()
  const { projectName, canManageProjects } = state || { projectName: '', canManageProjects: false }
  const navigate = useNavigate()
  const trackinProperties = {
    option: 'reopen',
  }

  const [activateProject, { loading }] = useMutation(ActivateProjectDocument, {
    extractorFn: (data: ActivateProjectMutation) =>
      data.projectManagementMutations.activateProjectmanagementProject,
  })

  const onClose = () => {
    navigate(-1)
  }

  const onSubmit = async () => {
    track(trackingEvents.projectManagement.projects.changeProjectStatusSubmit, trackinProperties)
    const response = await activateProject({
      variables: {
        id: String(projectId),
      },
      optimisticResponse: {
        projectManagementMutations: {
          activateProjectmanagementProject: {
            errors: [],
            project: {
              id: String(projectId),
              status: 'active',
            },
            __typename: 'ActivateProjectmanagementProjectPayload',
          },
        },
      },
    })
    handleResult(response, () => undefined)
    onClose()
  }

  if (!canManageProjects) return null

  const description = (
    <Text size="300">
      {i18n.tView('project_management.modals.activate_project.description', {
        project_name: (
          <Text size="300" weight="bold">
            {projectName}
          </Text>
        ),
      })}
    </Text>
  )
  return (
    <SingleActionModal
      onClose={onClose}
      onSubmit={onSubmit}
      loading={loading}
      title={i18n.t('project_management.modals.activate_project.title')}
      description={description}
      iconName={'document-folder-drawer-2'}
      submitButton={i18n.t('project_management.modals.activate_project.submit')}
    />
  )
}

export default ActivateProjectModalPage
